import { Skeleton } from '@cian/ui-kit/skeleton';
import * as React from 'react';

import * as styles from './OfferCardSkeleton.css';

function CardSkeleton() {
  return (
    <div className={styles['card']}>
      <Skeleton className={styles['photo']} width={298} height={237} borderRadius={16} />
      <div className={styles['content']}>
        <div className={styles['title-block']}>
          <Skeleton width="53%" height={36} borderRadius={12} />
          <Skeleton width="76%" height={24} borderRadius={12} />
          <Skeleton width="95%" height={24} borderRadius={12} />
        </div>
        <Skeleton width="57%" height={34} borderRadius={12} />
        <Skeleton width="96%" height={47} borderRadius={12} />
      </div>
    </div>
  );
}

interface IListingSkeletonProps {
  count: number;
}

export function ListingSkeleton({ count }: IListingSkeletonProps) {
  return (
    <div className={styles['root']}>
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  );
}
